import { Token } from '@pancakeswap/sdk'
import { createSelector } from '@reduxjs/toolkit'
import { useNetwork } from 'wagmi'
import { getChainId } from 'config/constants/exchange'
import { useSelector } from 'react-redux'
import { AppState } from '../../index'
import { deserializeToken } from './helpers'

const selectUserTokens = ({ user: { tokens } }: AppState) => tokens

export const userAddedTokenSelector = (chainId: number) =>
  createSelector(selectUserTokens, (serializedTokensMap) =>
    Object.values(serializedTokensMap?.[chainId] ?? {}).map(deserializeToken),
  )
export default function useUserAddedTokens(): Token[] {
  const { chain } = useNetwork()
  const chainId = getChainId(chain);
  return useSelector(userAddedTokenSelector(chainId))
}
